module.exports = __webpack_public_path__ + "img/INDUSTRIA.ceed2006.jpg";